// Handyfotos vor dem Hochladen verkleinern. Eine Kamera liefert 3 bis 12 MB je
// Bild, der Server nimmt höchstens 10 MB je Datei an (POST
// /api/tickets/:id/attachments). Auf 2560 px an der langen Seite verkleinert
// bleiben Typenschilder und Displays lesbar, und die Datei liegt bei rund
// 0,5 bis 1,5 MB.

export const FOTO_MAX_KANTE = 2560;
export const FOTO_QUALITAET = 0.85;
// Kleinere JPEGs gehen unverändert hoch: Jedes Neukodieren kostet Qualität.
export const FOTO_UNVERAENDERT_BIS = 1.5 * 1024 * 1024;

export function zielGroesse(breite, hoehe, maxKante = FOTO_MAX_KANTE) {
  const b = Math.max(0, Number(breite) || 0);
  const h = Math.max(0, Number(hoehe) || 0);
  const lang = Math.max(b, h);
  if (!lang || lang <= maxKante) return { breite: b, hoehe: h };
  const faktor = maxKante / lang;
  return { breite: Math.round(b * faktor), hoehe: Math.round(h * faktor) };
}

export function brauchtVerkleinerung(datei) {
  if (!datei || !/^image\//.test(datei.type || '')) return false;
  // GIF (Animation) und SVG (Vektor) würde das Neukodieren zerstören.
  if (/gif|svg/.test(datei.type)) return false;
  return !(datei.type === 'image/jpeg' && datei.size <= FOTO_UNVERAENDERT_BIS);
}

function ladeBild(datei) {
  if (typeof window.createImageBitmap === 'function') {
    // imageOrientation: Hochkant-Fotos bleiben hochkant (EXIF-Drehung).
    return window.createImageBitmap(datei, { imageOrientation: 'from-image' });
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(datei);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
}

// Gibt eine verkleinerte JPEG-Datei zurück oder, wenn das nicht geht oder
// nichts bringt, die Originaldatei. Ein Fehler hier darf den Upload nie
// verhindern.
export async function verkleinereFoto(datei) {
  if (!brauchtVerkleinerung(datei)) return datei;
  try {
    const bild = await ladeBild(datei);
    const { breite, hoehe } = zielGroesse(bild.width, bild.height);
    if (!breite || !hoehe) return datei;
    const canvas = document.createElement('canvas');
    canvas.width = breite;
    canvas.height = hoehe;
    canvas.getContext('2d').drawImage(bild, 0, 0, breite, hoehe);
    if (typeof bild.close === 'function') bild.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', FOTO_QUALITAET));
    if (!blob || blob.size >= datei.size) return datei;
    const name = String(datei.name || 'foto').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
  } catch (_) {
    // HEIC ohne Decoder o. Ä.: dann geht das Original hoch.
    return datei;
  }
}
